import { Allocation } from "@planzone/dto";

function isAllocationValid(allocation: Allocation): boolean {
  return allocation.allocatedHours >= 0;
}

export { isAllocationValid };
